/* -----------------Child components--------------- */
import { SessionContainer } from "@features/session";
import DocumentTitle from "components/DocumentTitle";

import { pageViewTypes } from "@constants/tracking";
import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
/* -----------------Globals--------------- */
import { Stack } from "expo-router";

const SessionRoute = () => {
	useAnalytics({
		type: pageViewTypes.session,
		eventName: events.sessionViewed,
	});

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Session" />
			<SessionContainer />
		</>
	);
};

export default SessionRoute;
